import { If } from "components";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useState } from "react";
import { ItemsTable } from "ui";

import { AdProductModal, DeleteAdProductModal } from "../../features";
import { useAdProductsColumns } from "../../hooks";
import { AdProductsTableProps } from "./AdProductsTable.types";

const AdProductsTable = ({
  adProducts,
  variantsById,
  isLoading
}: AdProductsTableProps) => {
  const [adProductId, setAdProductId] = useState<string | undefined>(undefined);

  const {
    value: isEditModalOpen,
    setTrue: openEditModal,
    setFalse: closeEditModal
  } = useBoolean();

  const {
    value: isDeleteModalOpen,
    setTrue: openDeleteModal,
    setFalse: closeDeleteModal
  } = useBoolean();

  const { columns } = useAdProductsColumns({
    variantsById,
    onOpenEdit: openEditModal,
    onOpenDelete: openDeleteModal,
    setAdProductId
  });

  return (
    <>
      <ItemsTable
        columns={columns}
        data={adProducts}
        isLoading={isLoading}
        skeletonHeight={56}
        emptyListMessage={t(
          "No ads are mapped yet. Paste the ad ID from Facebook Ads Manager and pick the products it shows — or put their short IDs in the ad's name."
        )}
      />

      <If condition={isEditModalOpen}>
        <AdProductModal
          isOpen
          onClose={closeEditModal}
          adProductId={adProductId}
        />
      </If>

      <If condition={isDeleteModalOpen}>
        <DeleteAdProductModal
          isOpen
          onClose={closeDeleteModal}
          adProductId={adProductId}
        />
      </If>
    </>
  );
};

export default AdProductsTable;
